import React, { useEffect, useState } from "react";
import Select from "react-select";
import "./style.scss";
import customStyles from "../../customStyles";
import DataBox from "../../reusableComponents/DataBox";
import { accountList } from "../../utils/store/reducers/accountSlice";
import { useDispatch, useSelector } from "react-redux";
import LoaderOverlay from "../../reusableComponents/LoaderOverlay/Index";
import { Pagination } from "@mui/material";
import Tabination from "../../reusableComponents/Tabs";
import { getPlatform } from "../../utils/store/reducers/accountMetricsSlice";
import { Link, useNavigate } from "react-router-dom";
import ReBillPopupModal from "../../reusableComponents/ReBillPopupModal/ReBillPopupModal";
import {
  getContractListRequest,
  getVeriffStatus,
} from "../../utils/apis/userApi";

import KycPopupModal from "../../reusableComponents/KycPopupModal/KycPopupModal";
import projectXIcon from "../../assets/images/ProjectX.png";
import tradovateIcon from "../../assets/icons/tradovate.svg";
import volumetricaIcon from "../../assets/icons/dxFeed.svg";
import alphaTraderIcon from "../../assets/icons/AlphaTrader.svg";

function Dashboard() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const dispatch = useDispatch();
  const { data, isLoading } = useSelector((state) => state.accountList);
  const { platForm_list } = useSelector((state) => state.accountMetrics.plans);
  const [accountData, setAccountData] = useState(data);
  const [contractList, setContractList] = useState(null);
  const [veriffStatus, setVeriffStatus] = useState(null);
  const navigate = useNavigate();
  const [showKYCModal, setShowKYCModal] = useState(false);

  useEffect(() => {
    setAccountData(data);
  }, [data]);
  const { idToken } = useSelector((state) => state?.auth);

  const [params, setParams] = useState({
    page: 1,
    page_size: 9,
    active: null,
    platform: null,
  });

  useEffect(() => {
    if (params.page && params.page_size && params?.platform) {
      dispatch(accountList({ idToken, params }));
    }
  }, [dispatch, idToken, params]);

  useEffect(() => {
    dispatch(getPlatform({ idToken }));
  }, [idToken]);

  const options = [
    { value: null, label: "All" },
    { value: "True", label: "Active" },
    { value: "False", label: "Inactive" },
  ];

  const handleChange = (selectedOption) => {
    setParams((pre) => ({ ...pre, active: selectedOption.value }));
  };

  const [brokers, setBrokers] = useState([]);
  const [activeTab, setActiveTab] = useState(0);

  useEffect(() => {
    setBrokers(
      platForm_list?.map((item) => {
        let icon = null;
        if (
          item.label.includes("ProjectX") ||
          item.label.includes("Quantower")
        ) {
          icon = projectXIcon;
        } else if (item.label.includes("Tradovate")) {
          icon = tradovateIcon;
        } else if (item.label.includes("Volumetrica")) {
          icon = volumetricaIcon;
        } else if (item.label.includes("Alpha Trader")) {
          icon = alphaTraderIcon;
        }

        return {
          name: (
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              {icon && (
                <img
                  src={icon}
                  alt={item.label}
                  style={{
                    width: "30px",
                  }}
                />
              )}
              {item.label}
            </div>
          ),
          path: item.value,
        };
      })
    );
  }, [platForm_list]);

  useEffect(() => {
    if (brokers && brokers?.length > 0) {
      setParams((prevParams) => ({
        ...prevParams,
        platform: brokers[activeTab]?.path,
        page: 1,
      }));
    }
  }, [activeTab, brokers]);

  useEffect(() => {
    let isMounted = true;

    const fetchLazyData = async () => {
      try {
        const [contracts, veriff] = await Promise.all([
          getContractListRequest(idToken, { page: 1, page_size: 5 }),
          getVeriffStatus(idToken),
        ]);

        if (isMounted) {
          const contractRes = contracts?.data || {};
          const veriffRes = veriff?.data || {};

          setContractList(contractRes);
          setVeriffStatus(veriffRes);

          if (
            contractRes?.results?.length > 0 &&
            ["unverified", "pending"].includes(veriffRes?.review_status) &&
            veriffRes?.is_verified === false
          ) {
            setShowKYCModal(true);
          }
        }
      } catch (err) {
        console.error("Lazy load error:", err);
      }
    };

    const timer = setTimeout(fetchLazyData, 500);

    return () => {
      isMounted = false;
      clearTimeout(timer);
    };
  }, [idToken]);

  const handleKycOkay = () => {
    setShowKYCModal(false);
    navigate("/profile/kyc");
  };

  return (
    <div className="dashboard">
      <ReBillPopupModal />
      {isLoading === true && <LoaderOverlay />}
      <div className="assessment-button-wrapper">
        <button className="standard-button">
          <Link to="/Assessments">Start New Challenge</Link>
        </button>
      </div>
      <div className="dashboard-filter-wrapper">
        <Tabination
          variant={1}
          tabItems={brokers}
          showTabs={true}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
        <Select
          value={options.find((item) => item.value === params.active)}
          onChange={handleChange}
          isSearchable={false}
          options={options}
          styles={customStyles}
        />
      </div>

      <div className="dashboard-box-wrapper">
        {accountData?.results?.map((data, index) => (
          <DataBox
            variant={"btns"}
            key={index}
            items={data}
            activeTab={activeTab}
          />
        ))}
      </div>
      {Math.ceil(accountData?.count / params.page_size) > 1 && (
        <div className="pagination-container">
          <Pagination
            count={Math.ceil(accountData?.count / params.page_size)}
            page={params.page}
            onChange={(e, page) => {
              setParams((prevParams) => ({ ...prevParams, page }));
            }}
            size="small"
            showFirstButton
            showLastButton
            shape="rounded"
            className="pagination"
          />
        </div>
      )}

      {/* ✅ KYC Modal */}
      <KycPopupModal
        visible={showKYCModal}
        onClose={() => setShowKYCModal(false)}
        onOkay={handleKycOkay}
      />
    </div>
  );
}

export default Dashboard;
